import { fetchPost, fetchGet , fetchPut , fetchDelete} from '@/utils/request'

export function getUserBlacklist (query) {  //用户手机黑名单列表
    return fetchGet('/gateway/v1/customer-mobile-blacklists',query)
}
export function getUserBlackDetail (id) {  //用户手机黑名单详情
    return fetchGet('/gateway/v1/customer-mobile-blacklists/'+id)
}
export function creatUserBlack (query) { //创建用户手机黑名单
    return fetchPost('/gateway/v1/customer-mobile-blacklists',query)
}
export function editUserBlack (id,query) { //修改用户手机黑名单
    return fetchPut('/gateway/v1/customer-mobile-blacklists/'+id,query)
}
export function deleteUserBlack (id) { //删除用户手机黑名单
    return fetchDelete('/gateway/v1/customer-mobile-blacklists/'+id)
}

export function getIpBlacklist (query) {  //ip黑名单列表
    return fetchGet('/gateway/v1/blacklist-ips',query)
}
export function getIpBlackDetail (id) {  //ip名单详情
    return fetchGet('/gateway/v1/blacklist-ips/'+id)
}
export function editIpBlack (id,query) { //修改ip黑名单
    return fetchPut('/gateway/v1/blacklist-ips/'+id,query)
}
export function deleteIpBlack (id) { //删除ip黑名单
    return fetchDelete('/gateway/v1/blacklist-ips/'+id)
}
export function creatIpBlack (query) { //创建ip黑名单
    return fetchPost('/gateway/v1/blacklist-ips ',query)
}



